module.exports = "<p>Make day (or a night) out of your visit. Settle in for a drink or a meal at one of the MCA’s stunning locations overlooking the Harbour.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/news/dining-excerpt.md
// module id = 815
// module chunks = 0